import { render, staticRenderFns } from "./loginelse.vue?vue&type=template&id=0aea66c0&scoped=true&"
import script from "./loginelse.vue?vue&type=script&lang=js&"
export * from "./loginelse.vue?vue&type=script&lang=js&"
import style0 from "./loginelse.vue?vue&type=style&index=0&id=0aea66c0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aea66c0",
  null
  
)

export default component.exports